var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: "32px",
    height: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.036,16.187c0.012,0.063,0.018,0.126,0.042,0.186c0.025,0.062,0.068,0.114,0.106,0.171 c0.031,0.046,0.047,0.098,0.086,0.139c0.007,0.008,0.018,0.01,0.025,0.018c0.008,0.008,0.011,0.02,0.02,0.028l16,15 C22.509,31.91,22.755,32,23,32c0.267,0,0.533-0.106,0.729-0.316c0.378-0.402,0.357-1.035-0.045-1.413L8.462,16L23.684,1.729 c0.403-0.378,0.423-1.011,0.045-1.413c-0.378-0.403-1.011-0.423-1.414-0.046l-16,15c-0.009,0.008-0.011,0.019-0.02,0.027 c-0.008,0.008-0.018,0.01-0.026,0.018c-0.039,0.042-0.056,0.093-0.086,0.139c-0.038,0.057-0.081,0.109-0.106,0.171 c-0.024,0.06-0.03,0.123-0.042,0.186c-0.012,0.063-0.03,0.123-0.03,0.187C6.006,16.064,6.024,16.124,6.036,16.187z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.f90eca59300561a4704fcc32052f580a.svg";
export { ForwardRef as ReactComponent };